// Merging duplicates when different streaks for the same game exist.
// The data is correct however this isn't very friendly for the user
const mergeDuplicates = (groupByFields: string[]) => (data: any[]) => {
    const dataMap = {};
    const filteredData: any[] = [];
    data.map((d) => {
        const key = groupByFields.map((field) => d[field]).join('-');
        if (!dataMap[key]) {
            dataMap[key] = true;
            filteredData.push(d);
        }
    });
    return filteredData;
};

const ENHANCE_RECORDS = {
    RECORDS_TEAM: {
        // Ex. 5 goal streak, opponent scores, another 5 goal streak
        'most-consecutive-goals-one-team-one-game': mergeDuplicates(['teamId', 'gameDate', 'consecutiveGoals']),
    },
    RECORDS_INDIVIDUAL: {
        // most-goals-50-games-from-season-start traded player
        'most-goals-50-games-from-season-start': mergeDuplicates(['seasonId', 'teamAbbrevs', 'playerId']),
    },
    RECORDS_GOALIE: {
        // longest-winning-streak-one-season: Goalie streak can occur with multiple teams
        'longest-winning-streak-one-season': mergeDuplicates(['playerId', 'franchiseId', 'startDate']),
    },
};

export default (data, templateKey, pageName) => {
    const recordEnhancement = ENHANCE_RECORDS[templateKey]?.[pageName];
    return recordEnhancement ? recordEnhancement(data) : data;
};
